var map = {
	"../cases/cases.module": [
		"kioc",
		1,
		0,
		6
	],
	"../content/content.module": [
		"cb0t",
		0,
		7
	],
	"../org-settings/org-settings.module": [
		"y4aV",
		2,
		0,
		9
	],
	"../patient-procedures/patient-procedures.module": [
		"XCTk",
		2,
		1,
		4,
		0,
		10
	],
	"../patient/patient.module": [
		"5KnL",
		2,
		1,
		4,
		0
	],
	"../recall-calls/recall-calls.module": [
		"jA+3",
		13
	],
	"../referrals/referrals.module": [
		"1dRQ",
		0,
		14
	],
	"../reports/reports.module": [
		"A/Z4",
		0,
		15
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;